import React, { useEffect, useState, Fragment } from 'react'
import MainTitle from '../common/MainTitle'
import CustomHr from '../common/CustomHr'
import ImageCardWithAttributes from '../common/ImageCardWithAttributes'
import ImageCardWithAttributesResume from '../common/ImageCardWithAttributesResume'

const SequenceContainer = ({ id, result, attributes, session, selectedName, results, fixedElement }) => {
    const [updatedResources, setUpdatedResources] = useState([]);  
    const [votes, setVotes] = useState([]);
    const [width, setWidth] = useState(0)
    const [height, setHeight] = useState(0)
    const [totalAttibutes, setTotalAttributes] = useState([])
    const { sequence } = result
    const { resources } = sequence
    const generateVotes = (result) => {
        let votes = [];
    
        for (let [key, value] of Object.entries(result)) {
            if (value.scores) {
                value.scores.forEach(score => {
                    votes.push({
                        name: key,
                        voter: score.participantName,
                        score: score.score
                    });
                });
            }
        }
    
        return votes;
    };
    //Intégation de le channel fixe dans la liste des ressources 
    useEffect(() => {
        if (sequence && sequence.resources) {
            const newResources = [...sequence.resources];
            // Si fixedElement existe et est un objet, il s'ajoute à la liste des ressources 
            if (fixedElement && typeof fixedElement === 'object') {
                newResources.push(fixedElement);
            }
            setUpdatedResources(newResources);
        }
    }, [sequence, fixedElement])
    
    

    useEffect(() => {
        setVotes(generateVotes(result));
    }, [result]);

    const formatImageSize = () => {
        if (!resources || !resources[0] || !resources[0].downloadURL) {
            console.warn('No valid image resource found');
            return;
        }
    
        const img = new Image();
        
        img.onerror = () => {
            console.error('Failed to load image:', resources[0].downloadURL);
            setHeight(400);
            setWidth(400);
        };
    
        img.onload = () => {
            const { height: originalHeight, width: originalWidth } = img;
            
            const coef = calculateResizeCoefficient(originalHeight);
            
            const newHeight = originalHeight / coef;
            const newWidth = originalWidth / coef;
            
            setHeight(newHeight);
            setWidth(newWidth);
        };
    
        img.src = resources[0].downloadURL;
    };
    
    const calculateResizeCoefficient = (height) => {
        const SIZE_THRESHOLDS = {
            SMALL: 800,
            MEDIUM: 1000,
            LARGE: 1500,
            XLARGE: 2000
        };
    
        if (height <= SIZE_THRESHOLDS.SMALL) {
            return 1;
        } else if (height <= SIZE_THRESHOLDS.MEDIUM) {
            return 1.5;
        } else if (height <= SIZE_THRESHOLDS.LARGE) {
            return 2;
        } else if (height <= SIZE_THRESHOLDS.XLARGE) {
            return 3;
        } else {
            return 4;
        }
    };
    useEffect(() => {
        formatImageSize()

        let totals = []
        if (attributes && attributes[0]) {
            sequence.resources.forEach((channel, i) => {
                const channelResult = result[channel.name];
                if (channelResult && channelResult.scores) {
                    // Ajouter les scores au canal
                    channel.scores = channelResult.scores;
                }

                const ressource = session.data.mcCriterias.find(crit => crit.id === channel.id)

                attributes.forEach((at, y) => {
                    if (totals[y]) {
                        totals[y] = totals[y] + (Number(ressource.attributes[y].quantity) * result[channel.name].average / 100)
                    } else {
                        totals.push((Number(ressource.attributes[y].quantity) * result[channel.name].average / 100))
                    }
                })

                if (i === sequence.resources.length - 1) {
                    setTotalAttributes(totals)
                }
            })
        }
        // eslint-disable-next-line 
    }, [])
    
    return (
        <div>
            <MainTitle text={`Sequence ${id}`} />
            <div className="row multiple-channel-criteria-resume"  >
                <div className="col-xs-12 result">
                    <div className="row margin-bottom-large">
                        <div className="resource-wrapper">
                            <div className="resources" style={{ width: (width + "px"), height: (height + "px") }}>
                            {updatedResources.map((channel, index) => {
                                let opacity;
                                // Si le canal est fixe, l'opacité est de 1
                                if (channel.isFixed) {
                                    opacity = 1;
                                } else if (selectedName && selectedName !== "") {
                                    const vote = votes.find(vote => vote.name === channel.name && vote.voter === selectedName);
                                    opacity = vote ? vote.score / 100 : 0;
                                } else {
                                    opacity = result[channel.name].average / 100;
                                }

                                return (
                                    <img
                                        key={index}
                                        className="img-responsive"
                                        alt="Resource (Multiple Channel)"
                                        src={channel.downloadURL}
                                        style={{ opacity }}
                                    />
                                );
                            })}
                            </div>
                        </div>
                    </div>
                    <div>
                        <Fragment>
                             <div className="attributes-results new-results text-center" >
                                {resources.map((channel, index) => {
                                    let ressource = session.data.mcCriterias.find(crit => crit.id === channel.id)
                                    return (
                                        <ImageCardWithAttributes
                                        key={index}
                                        channelName={channel.name}
                                        channelAverage={result[channel.name].average}
                                        attributes={attributes}
                                        ressource={ressource}
                                        result={result} 
                                        votes={votes}
                                        selectedName={selectedName}
                                        />
                                        )
                                    })}
                            </div>
                            {attributes && attributes[0] && (
                                <ImageCardWithAttributesResume
                                    index={id}
                                    attributes={attributes}
                                    totalAttibutes={totalAttibutes}
                                    ressourcesLength={resources.length}
                                />
                            )}
                        </Fragment>
                        <CustomHr />
                    </div>
                </div>
            </div>
        </div >
    )
}

export default SequenceContainer
